import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Ledger: [],
  Detail: [],
  Incharge: [],
  Commission: [],
  Lead: [],
};
//internally using immer lib (can create mutable state)
export const attendenceSlice = createSlice({
  name: "viewData",
  initialState,
  reducers: {
    updateAllLeadger: (state, action) => {
      state.Ledger = action.payload;
    },
    updateLeadgerDetail: (state, action) => {
      state.Detail = action.payload;
    },
    getInchargeUnder: (state, action) => {
      state.Incharge = action.payload;
    },
    getComission: (state, action) => {
      state.Commission = action.payload;
    },
    getLead: (state, action) => {
      state.Lead = action.payload;
    },
  },
});
// this is for dispatch
export const { updateAllLeadger, updateLeadgerDetail, getInchargeUnder, getComission, getLead } = attendenceSlice.actions;
// this is for configureStore
export default attendenceSlice.reducer;
